import Spinner from "../../../Components/Loader/Spinner";
import SVG from "../../../Components/SVG";
import MobileCarousel from "../../../Components/Cards/Information/MobileCarousel";

export default function CumStats({ accountData, accLoading }) {
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <h3 className="flex items-center gap-2.5">
        <SVG
          name="stats2"
          classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5"
        />
        <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          اطلاعات تجمعی
        </span>
      </h3>

      {accLoading ? (
        <div className="w-full h-[195px] flex justify-center items-center">
          <Spinner color="#8080804D" />
        </div>
      ) : (
        <MobileCarousel
          mobileFullWidth
          alignStart
          itemLabel="بخش اطلاعات تجمعی"
          className="text-nowrap mb:!justify-between mb:gap-20 mb:overflow-x-auto"
        >
          <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-y-0 px-7 mb:px-0">
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                اکوییتی
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(accountData?.details?.equity).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                بالانس
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(accountData?.details?.balance).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark text-nowrap">
                میانگین سود معاملات موفق
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(
                      accountData?.details?.average_winning_trade_pnl
                    ).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                میانگین ضرر معاملات ناموفق
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                -$
                {accountData?.details?.average_losing_trade_pnl &&
                  Number(
                    Number(
                      accountData?.details?.average_losing_trade_pnl
                        .toString()
                        .replace(/^-/, "")
                    ).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
          </article>

          <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-y-0 px-7 mb:px-0">
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                تعداد کل معاملات
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                {accountData?.details?.closed_trades_count}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                مجموع حجم معاملات
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(accountData?.details?.used_margin_usdt).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                نرخ پیروزی
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                {accountData?.details &&
                  Number(accountData?.details?.win_rate).toFixed(2)}
                %
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                نرخ شکست
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                {accountData?.details &&
                  Number(accountData?.details?.loss_rate).toFixed(2)}
                %
              </p>
            </div>
          </article>

          <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-y-0 px-7 mb:px-0">
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                بهترین معامله
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(
                      accountData?.details?.best_closed_winning_trade_pnl
                    ).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                بدترین معامله
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                -$
                {accountData?.details &&
                  Number(
                    Number(
                      accountData?.details?.worst_closed_losing_trade_pnl
                        .toString()
                        .replace(/^-/, "")
                    ).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                مجموع سود معاملات موفق
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                $
                {accountData?.details &&
                  Number(
                    Number(accountData?.details?.gross_profit).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
            <div className="card-divider hidden dark:block w-full h-px bg-[linear-gradient(90deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)]" />
            <div className="flex justify-between items-center py-3 gap-2.5">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                مجموع ضرر معاملات ناموفق
              </p>
              <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
                -$
                {accountData?.details &&
                  Number(
                    Number(
                      accountData?.details?.gross_loss
                        .toString()
                        .replace(/^-/, "")
                    ).toFixed(2)
                  ).toLocaleString()}
              </p>
            </div>
          </article>
        </MobileCarousel>
      )}
    </div>
  );
}
